<template>
    <!--== View Story ==-->
    <article style="position: relative;">
        <v-overlay v-model="loading" contained class="align-center justify-center" scrim="transparent" persistent>
            <v-progress-circular color="amber" indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div v-if="form.story">
            <h1 class="text-center m-5">View Story</h1>
            <div class="row justify-content-center mx-5" style="word-wrap: break-word;">
                <textarea v-model="form.story"
                    class="text-justify col-12 col-md-8 bg-body-tertiary shadow-sm rounded-2 p-3 mb-5" rows="7" type="text"
                    required disabled />
            </div>

            <div class="d-grid gap-2 d-sm-block text-sm-center my-5 mx-5" v-if="isAccepted === null">
                <a class="btn btn-primary btn-lg fw-semibold text-white mx-2" style="--bs-btn-padding-x: 2rem" role="button"
                    @click="approve">
                    Approve
                </a>
                <a class="btn btn-danger btn-lg fw-semibold text-white mx-2" style="--bs-btn-padding-x: 2rem" role="button"
                    @click="decline">
                    Decline
                </a>
            </div>
            <div class="d-grid gap-2 d-sm-block text-sm-center my-5 mx-5" v-else-if="isAccepted === true">
                <a class="btn btn-danger btn-lg fw-semibold text-white mx-2" style="--bs-btn-padding-x: 2rem" role="button"
                    @click="decline">
                    Decline
                </a>
            </div>
            <div class="d-grid gap-2 d-sm-block text-sm-center my-5 mx-5" v-else>
                <a class="btn btn-primary btn-lg fw-semibold text-white mx-2" style="--bs-btn-padding-x: 2rem" role="button"
                    @click="approve">
                    Approve
                </a>
            </div>
        </div>

        <div v-else>
            <h1 class="text-center m-5">Beneficiary data not found</h1>
        </div>

    </article>
</template>

<script>
import { reactive, computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getDoc, doc, updateDoc } from 'firebase/firestore'
import { db } from "@/firebase"
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
    setup() {
        const router = useRouter()
        const route = useRoute()
        const beneficiaryId = computed(() => route.params.id)
        const isAccepted = ref()
        const form = reactive({ story: '' })
        const loading = ref(true)

        // Get beneficiary data if it exists
        const getBeneficiary = async (beneficiaryId) => {
            const beneficiary = await getDoc(doc(db, 'Gift Giving Applications', beneficiaryId))
            loading.value = false // Hide loading once done fetching data
            return beneficiary.exists ? beneficiary.data() : null
        }

        onMounted(async () => {
            const beneficiary = await getBeneficiary(beneficiaryId.value)

            // Assign values only if beneficiary exists
            if (beneficiary) {
                form.story = beneficiary.Story
                isAccepted.value = beneficiary.IsAccepted
            }

        })

        const approve = async () => {
            await updateDoc(doc(db, "Gift Giving Applications", beneficiaryId.value), {
                IsAccepted: true
            })

            toast.success("Volunteer sucessfully approved", {
                autoClose: 2000,
            })

            if (isAccepted.value === null) {
                router.push('/beneficiaries')
            } else {
                router.push('/declined-beneficiaries')
            }

        }

        const decline = async () => {
            await updateDoc(doc(db, "Gift Giving Applications", beneficiaryId.value), {
                IsAccepted: false
            })

            toast.success("Volunteer sucessfully declined", {
                autoClose: 2000,
            })

            if (isAccepted.value === null) {
                router.push('/beneficiaries')
            } else {
                router.push('/approved-beneficiaries')
            }
        }

        return { approve, decline, form, isAccepted, loading }
    }
}

</script>

<style scoped src="@/assets/css/admin.css"></style>